import type { variables } from '../mpanels/variables';

type Variables = typeof variables;

const createMuiOutlinedInputStyles = (variables: Variables) => ({
    styleOverrides: {
        root: {
            fontFamily: variables.fonts.additional,

            '& input': {
                padding: variables.padding.inputsDefault,
            },

            '& .MuiOutlinedInput-notchedOutline, & .MuiPickersOutlinedInput-notchedOutline': {
                borderColor: variables.colors.other.inputs.default,
                transition: 'border-color 0.15s ease-in-out',
            },

            '&:hover .MuiOutlinedInput-notchedOutline, &:hover .MuiPickersOutlinedInput-notchedOutline':
                {
                    borderColor: variables.colors.other.inputs.hover,
                },

            '&.Mui-focused .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiPickersOutlinedInput-notchedOutline':
                {
                    borderColor: variables.colors.other.inputs.focus,
                },

            '.ProfileQuestionsContent &:has(:not([value=""]):not(:focus):invalid)': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: variables.colors.other.text.error,
                },
                '& .MuiInputAdornment-root': {
                    color: variables.colors.other.text.error,
                },
            },

            '.OTPFieldInput': {
                width: '20px',
                height: '30px',
                marginTop: '-4px',
            },
        },
    },
});

export default createMuiOutlinedInputStyles;
